import React, {useEffect, useMemo, useState} from 'react';
import {Popup, Position, ToolbarItem} from "devextreme-react/popup";
import {Button, DateBox, NumberBox, TextBox} from "devextreme-react";
import ITrancheAge from "../../models/ITrancheAge";
import DataGrid from 'devextreme-react/data-grid';
import { CheckBox } from 'devextreme-react/check-box';
import Form, { GroupItem, SimpleItem } from "devextreme-react/form";

interface IPopupRenouvelerProps {
    isPopupOpen: boolean,
    onClose: () => void
    onRenouvele: () => void
}

function TrancheAge({trancheAge}: { trancheAge: ITrancheAge }) {
    return <>
        <div style={{gridColumn: 1}}>{`${trancheAge.isAdulte ? "Adultes " : "Enfant"} de ${trancheAge.ageDebut} ${trancheAge.ageFin >= 99 ? "et plus" : ` à ${trancheAge.ageFin} ans`}: `}</div>
        <NumberBox style={{gridColumn: 2}}/>
    </>;
}

function PopupRenouveler({isPopupOpen, onClose, onRenouvele}: IPopupRenouvelerProps) {
    const [dateCourrantePop, setDateCourrantePop] = useState(new Date());

    const idSelectOptions = useMemo(() => {
      return { items: [] }
    }, []);
  
    const onCurrentDateChangeDatePop = (date: Date) => {
      // setDateCourrantePop(date)
    }
  
    const buttonAttributes = {
      class: 'popup-depot-bouton-cta'
    }
  
    const checkBoxAttributes = {
      class: 'popup-depot-bouton-cta'
    }
  
    return (
      <Popup
        dragEnabled={true}
        visible={isPopupOpen}
        hideOnOutsideClick={false}
        showCloseButton={false}
        showTitle={true}
        title="Parametre de renouvellements"
        container=".dx-viewport"
      >
        <div className='wrapper-content-pop'>
          <div>
            <div className='wrapper-toolbar-pop'>
              <div className='popup-depot-bouton-cta'>
                <Form alignItemLabelsInAllGroups={true} formData={{}} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                  <GroupItem colSpan={4}>
                    <SimpleItem key={"frm-id-select"} editorType={"dxSelectBox"}
                      editorOptions={idSelectOptions} />
                  </GroupItem>
                </Form>
              </div>
              <div>
                <Button
                  text="Trouver"
                  type="normal"
                  elementAttr={buttonAttributes}
                  onClick={() => console.warn()}
                />
              </div>
              <div>
                <Button
                  text="Effacer"
                  type="normal"
                  elementAttr={buttonAttributes}
                  onClick={() => console.warn()}
                />
              </div>
              <div>
                <DateBox type={"date"} value={dateCourrantePop} onValueChanged={(props) => onCurrentDateChangeDatePop(props.value)} />
              </div>
            </div>
            <DataGrid
              keyExpr="ID"
              dataSource={[]}
              showBorders={true}
            //   defaultColumns={columnsPopUp}
            />
          </div>
          {/** Footer*/}
          <div className='content-footer-pop'>
            <div className='footer-row-check-box'>
              <div style={{ display: "flex" }}>
                <div>
                  <CheckBox defaultValue={false} elementAttr={checkBoxAttributes} />
                </div>
                <div>Afficher uniquement les reservations du jours</div>
              </div>
              <div> 0 resultats</div>
            </div>
            <div className='footer-button'>
              {/* <div>
                <Button
                  text="consulter la facture"
                  type="normal"
                  elementAttr={buttonAttributes}
                  onClick={() => console.warn()}
                />
                <Button
                  text="consulter la reservation"
                  type="normal"
                  disabled={true}
                  onClick={onClose}
                />
              </div> */}
              <div>
                <Button
                  text="Ok"
                  type="normal"
                  elementAttr={buttonAttributes}
                  onClick={() => console.warn()}
                />
                <Button
                  text="Annuler"
                  type="normal"
                  onClick={onClose}
                />
              </div>
            </div>
          </div>
        </div>
  
      </Popup >
    );
}

export default PopupRenouveler;